import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getServiceById, updateServiceById } from "../../actions/userAuth";
import { enqueueSnackbar } from "notistack";

const DeactivationDialog = ({ addDeactivation, setAddDeactivation }) => {
    const closeHandler = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setAddDeactivation(false)
    };
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [serviceStatus, setServiceStatus] = useState("");
    const { id } = useParams();
    console.log("This is id from deactivation = ",id);
    useEffect(() => {
        dispatch(getServiceById({ id }, (data) => {
            console.log(data.data.data);
            const serviceData = data.data.data;
            setServiceStatus(serviceData.serviceStatus)
        }, (err) => {
            console.log(err);
        }));
    }, [dispatch, id]);

    const handleDeactivate = () => {
        console.log("Clicked")
        if (serviceStatus == "ACTIVE" || serviceStatus == "CLOSING-SOON") {
            setServiceStatus("DE-ACTIVE")
            let payload = { "serviceStatus": serviceStatus || "DE-ACTIVE" }
            dispatch(
                updateServiceById(id, payload, (data) => {
                    enqueueSnackbar('Service Deactivated Successfully!', { variant: 'success' });
                    navigate("/coach/services-status");
                }, (err) => {
                    enqueueSnackbar("Error Occured! Please try again", { variant: 'warning' });
                })
            );
        } else {
            enqueueSnackbar("You cannot change service status", { variant: 'error' });
        }

    }


    return (
        <>
            <Dialog
                open={addDeactivation}
                onClose={closeHandler}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography className="subHeading1Bold" sx={{ marginLeft: 'auto' }}>Service Deactivation Alert!</Typography>
                    <CloseIcon sx={{ float: 'right', cursor: 'pointer', marginLeft: 'auto' }} onClick={closeHandler} />
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <Typography className="text1Mid">
                        The service will Deactivated For new Candidates But Will be Active Existing Candidates.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#2544EE' }}>
                    <Button className="text1Mid" sx={{ color: '#000', background: '#FFF', px: 5 }} onClick={handleDeactivate}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DeactivationDialog;